import { useEffect, useState } from 'react';
import { computeOpenStatus, getShopInfo } from '../lib/twin';
import type { OpenStatus } from '../lib/twin';

/**
 * Recompute open/closed status from live shop hours on a timer so the badge
 * stays correct as the clock crosses opening/closing without a reload.
 */
export function useOpenStatus(intervalMs = 30_000): OpenStatus {
  const hours = getShopInfo().hours;
  const [status, setStatus] = useState<OpenStatus>(() => computeOpenStatus(hours));

  useEffect(() => {
    const tick = () => setStatus(computeOpenStatus(hours));
    tick();
    const id = window.setInterval(tick, intervalMs);
    return () => window.clearInterval(id);
  }, [hours, intervalMs]);

  return status;
}
